export default "__VITE_ASSET__0491fc4c__"